// import 'alpinejs';

function init() {
  // INSERT STUFF IF NEEDED
}

export default {
  init,
};
